import React, { useCallback, useEffect, useState } from "react";
import Layout from "../../Layout";
import * as RB from "react-bootstrap";
import DataTable from "react-data-table-component";
import Swal from "sweetalert2";
import EditIcon from "@mui/icons-material/Edit";
import { Delete } from "@mui/icons-material";
import * as utils from "../../Utils/comman";
import { Edit2, Trash } from "iconsax-react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import CustomPagination from "../../Utils/CustomPagination";

function Subjects() {
  const [subject, setSubject] = useState("");
  const [isActive, setIsActive] = useState("");
  const [validated, setValidated] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);
  const [subjectList, setSubjectList] = useState([]);
  const [isEdit, setIsEdit] = useState(false);
  const [editId, setEditId] = useState("");
  const [page, setPage] = useState(1);
  const countPerPage = 10;
  const statusList = [
    { id: "", name: "Select an option..." },
    { id: "1", name: "Active" },
    { id: "0", name: "Inactive" },
  ];
  const primaryMenuRes = useSelector(
    (state) => state?.primaryMenu?.primaryMenu?.permissions
  );

  const columns = [
    {
      name: "Subject",
      selector: (row) => row.subject_name,
    },
    {
      name: "Status",
      selector: (row) => (row.isActive === "1" ? "Active" : "Inactive"),
    },
    {
      name: "Action",
      cell: (row) => (
        <>
          {utils.hasPermission(primaryMenuRes, "Subject", "subject.edit") && (
            <RB.Button className="btn-flat" onClick={() => handleEdit(row)}>
              <Edit2 />
            </RB.Button>
          )}
          &nbsp;
          {utils.hasPermission(
            primaryMenuRes,
            "Subject",
            "subject.delete"
          ) && (
            <RB.Button className="btn-flat" onClick={() => showDelete(row)}>
              <Trash />
            </RB.Button>
          )}
        </>
      ),
    },
  ];

  useEffect(() => {
    getSubjectList();
  }, [page]);

  const getSubjectList = () => {
    utils
      .callAPI("get", `/meeting/subject/list?page=${page}&per_page=${countPerPage}`)
      .then((res) => {
        if (typeof res !== "undefined") {
          setSubjectList(res);
        } else {
          setSubjectList([]);
        }
      })
      .catch((err) => {
        setSubjectList([]);
      });
  };

  const handleEdit = useCallback((row) => {
    setIsEdit(true);
    setSubject(row.subject_name);
    setIsActive(row.isActive);
    setEditId(row.id);
  }, []);

  const showDelete = useCallback((row) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this data!",
      icon: "warning",
      showDenyButton: true,
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        utils
          .callAPI("get", `/meeting/subject/delete?id=${row.id}`)
          .then((res) => {
            if (typeof res !== "undefined") {
              getSubjectList();
            }
          })
          .catch((err) => {});
      }
    });
  }, []);

  const handleNameChange = (event) => {
    setSubject(event.target.value);
  };

  const handleStatusChange = (event) => {
    setIsActive(event.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;

    if (form.checkValidity() === false) {
      e.stopPropagation();
      setValidated(true);
    } else {
      setIsSubmit(true);
    }
  };

  useEffect(() => {
    if (isSubmit) {
      var bodyFormData = new FormData();
      if (isEdit) {
        bodyFormData.append("id", editId);
      }
      bodyFormData.append("subject_name", subject);
      bodyFormData.append("isActive", isActive);

      utils
        .callAPI("post", `/meeting/subject/save`, bodyFormData)
        .then((res) => {
          if (typeof res !== "undefined") {
            setIsSubmit(false);
            getSubjectList();
            setSubject("");
            setIsActive("");
          } else {
            setIsSubmit(false);
          }
        })
        .catch((err) => {
          setIsSubmit(false);
        });
    }
  }, [isSubmit]);

  const handleClear = () => {
    setSubject("");
    setIsActive("");
    setIsEdit(false);
    setEditId("");
  };

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  return (
    <Layout>
      <div className="main-content">
        <section className="section">
          <div className="section-header">
            <h1>Subject</h1>
          </div>
          <div className="section-body">
            <RB.Card className="">
              <RB.Card.Body>
                <RB.Row>
                  {utils.hasPermission(
                    primaryMenuRes,
                    "Subject",
                    "subject.create"
                  ) && (
                    <RB.Col md={4}>
                      <RB.Card className="shadow-1">
                        <RB.Card.Body>
                          <RB.Form
                            noValidate
                            validated={validated}
                            onSubmit={handleSubmit}
                          >
                            <div className="mb-3">
                              <RB.FloatingLabel
                                controlId="subject"
                                label="Subject"
                                className="floating-label-fancy"
                              >
                                <RB.Form.Control
                                  type="text"
                                  placeholder="Enter Subject"
                                  value={subject}
                                  onChange={handleNameChange}
                                  required
                                />
                                <RB.Form.Control.Feedback type="invalid">
                                  Please enter subject name.
                                </RB.Form.Control.Feedback>
                              </RB.FloatingLabel>
                            </div>

                            <div className="mb-3">
                              <RB.FloatingLabel
                                controlId="isActive"
                                label="Status"
                                className="floating-label-fancy"
                              >
                                <RB.Form.Select
                                  value={isActive}
                                  onChange={handleStatusChange}
                                  required
                                >
                                  {statusList.map((status) => (
                                    <option key={status.id} value={status.id}>
                                      {status.name}
                                    </option>
                                  ))}
                                </RB.Form.Select>
                                <RB.Form.Control.Feedback type="invalid">
                                  Please select status.
                                </RB.Form.Control.Feedback>
                              </RB.FloatingLabel>
                            </div>
                            <div className="d-flex align-items-center gx-3">
                              <div className="text-start">
                                <RB.Button type="submit" variant="primary">
                                  Submit
                                </RB.Button>
                              </div>
                              <div>
                                <Link
                                  className="text-underline ms-3"
                                  onClick={handleClear}
                                >
                                  {"Clear"}
                                </Link>
                              </div>
                            </div>
                          </RB.Form>
                        </RB.Card.Body>
                      </RB.Card>
                    </RB.Col>
                  )}
                  {utils.hasPermission(
                    primaryMenuRes,
                    "Subject",
                    "subject.view"
                  ) && (
                    <RB.Col md={8}>
                      <RB.Card className="shadow-1">
                        <RB.Card.Body>
                          <DataTable
                            columns={columns}
                            data={subjectList.result}
                            highlightOnHover
                            responsive
                            pagination
                            paginationServer
                            paginationTotalRows={subjectList.total}
                            paginationPerPage={countPerPage}
                            paginationComponentOptions={{
                              noRowsPerPage: true,
                            }}
                            paginationComponent={() => (
                              <CustomPagination
                                currentPage={page}
                                totalRows={subjectList.total}
                                rowsPerPage={countPerPage}
                                onPageChange={handlePageChange}
                              />
                            )}
                            striped
                            onChangePage={(page) => setPage(page)}
                            persistTableHead
                            customStyles={{
                              head: {
                                style: {
                                  fontSize: "0.875rem", // Adjust the font size as needed
                                  fontWeight: "bold", // Adjust the font weight as needed
                                },
                              },
                            }}
                          />
                        </RB.Card.Body>
                      </RB.Card>
                    </RB.Col>
                  )}
                </RB.Row>
              </RB.Card.Body>
            </RB.Card>
          </div>
        </section>
      </div>
    </Layout>
  );
}

export default Subjects;
